import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';

const propsSchema = [ 
  {
    key: 'general',
    label: 'General',
    type: types.OBJECT,
    children: [
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT,
      },
      {
        key: 'subtitle',
        label: 'Subtitle',
        type: types.TEXT,
      },
      {
        key: 'width',
        label: 'Width',
        type: types.TEXT,
      },
      {
        key: 'backgroundColor',
        label: 'Background Color',
        type: types.COLOR_PICKER,
      },
      {
        key: 'padding',
        label: 'Padding',
        type: types.TEXT,
      },
      {
        key: 'titlePadding',
        label: 'Title Padding',
        type: types.TEXT,
      },
      // {
      //   key: 'titleAlignment',
      //   label: 'Title Alignment',
      //   type: types.ENUM,
      //   options: ['left', 'center', 'right'],
      // },
      {
        key: 'sectionTitlePadding',
        label: 'Section Title Padding',
        type: types.TEXT,
      },
    ]
  },
  {
    key: 'sections',
    label: 'Sections',
    type: types.ARRAY,
    children: [
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT,
      },
      {
        key: 'image',
        label: 'Image',
        type: types.ARRAY,
        children: [
          {
            key: 'url',
            label: 'Image URL',
            type: types.TEXT,
          },
          {
            key: 'description1',
            label: 'Description 1',
            type: types.TEXT,
          },
          {
            key: 'description2',
            label: 'Description 2',
            type: types.TEXT,
          },
        ],
      },
    ]
  }
];

const defaultProps = {
  general: {
    title: 'Image Sections',
    subtitle: 'Image Sections Subtitle',
    backgroundColor: '#000',
    padding: '40px 10% 40px 10%',
    width: '100%',
    titlePadding: '0 0 0 15%',
    sectionTitlePadding: '40px 0 20px 15%',
  },
  sections: [
    {
      title: 'Image Section 1',
      image: [
        {
          url: 'https://genesis-cdn.ff.com/press_room/2025-10/LandingPage/Countdown/2dcd/IMG_6045_2880x1800-default.jpg',
          description1: 'Description 1',
          description2: 'Description 2',
        },
        {
          url: 'https://genesis-cdn.ff.com/press_room/2025-10/LandingPage/Countdown/2dcd/IMG_6045_2880x1800-default.jpg',
          description1: 'Description 1',
          description2: 'Description 2',
        },
        {
          url: 'https://genesis-cdn.ff.com/press_room/2025-10/LandingPage/Countdown/2dcd/IMG_6045_2880x1800-default.jpg',
          description1: 'Description 1',
          description2: 'Description 2',
        },
        {
          url: 'https://genesis-cdn.ff.com/press_room/2025-10/LandingPage/Countdown/2dcd/IMG_6045_2880x1800-default.jpg',
          description1: 'Description 1',
          description2: 'Description 2',
        },
        {
          url: 'https://genesis-cdn.ff.com/press_room/2025-10/LandingPage/Countdown/2dcd/IMG_6045_2880x1800-default.jpg',
          description1: 'Description 1',
          description2: 'Description 2',
        },
        {
          url: 'https://genesis-cdn.ff.com/press_room/2025-10/LandingPage/Countdown/2dcd/IMG_6045_2880x1800-default.jpg',
          description1: 'Description 1',
          description2: 'Description 2',
        },
      ]
    },
    {
      title: 'Image Section 2',
      image: [
        {
          url: 'https://genesis-cdn.ff.com/press_room/2025-10/LandingPage/Countdown/2dcd/IMG_6045_2880x1800-default.jpg',
          description1: 'Description 1',
          description2: 'Description 2',
        },
        {
          url: 'https://genesis-cdn.ff.com/press_room/2025-10/LandingPage/Countdown/2dcd/IMG_6045_2880x1800-default.jpg',
          description1: 'Description 1',
          description2: 'Description 2',
        },
        {
          url: 'https://genesis-cdn.ff.com/press_room/2025-10/LandingPage/Countdown/2dcd/IMG_6045_2880x1800-default.jpg',
          description1: 'Description 1',
          description2: 'Description 2',
        },
        {
          url: 'https://genesis-cdn.ff.com/press_room/2025-10/LandingPage/Countdown/2dcd/IMG_6045_2880x1800-default.jpg',
          description1: 'Description 1',
          description2: 'Description 2',
        },
        {
          url: 'https://genesis-cdn.ff.com/press_room/2025-10/LandingPage/Countdown/2dcd/IMG_6045_2880x1800-default.jpg',
          description1: 'Description 1',
          description2: 'Description 2',
        },
        {
          url: 'https://genesis-cdn.ff.com/press_room/2025-10/LandingPage/Countdown/2dcd/IMG_6045_2880x1800-default.jpg',
          description1: 'Description 1',
          description2: 'Description 2',
        },
      ]
    }
  ]
}

export default {
  title: 'Image Sections',
  id: 'ImageSections',
  propsSchema,
  defaultProps
}